import { Upload, Button } from "antd";
import React from "react";
import styled from "styled-components";

import { Text } from "@components/Text";

const DeviceContainer = styled.div`
  width: 1920px;
  height: 1080px;
  background: red;
`;

const CampaignContainer = styled.div`
  width: 100%;
  height: 100%;
  background: green;
`;

const BlockContainer = styled.div`
  width: 896px;
  height: 600px;
  background: blue;
`;

const SectionDownloading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  background: white;
  color: black;
  z-index: 30000;
  padding: 0.25rem 1.25rem;
  font-size: 1.5rem;
  opacity: 0.7;
  animation: blinker 1s infinite;

  @keyframes blinker {
    0% {
      opacity: 0.7;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 0.7;
    }
  }
`;

export default () => {
  return (
    <DeviceContainer>
      <CampaignContainer>
        <BlockContainer>
          <img
            src="https://get-led-api.forvizdev.com/uploads/medias/customer_1/location_1/878563f8-24b9-4358-ac65-d1d6728a397b.jpg"
            alt="-"
            style={{ width: "100%", height: "100%", objectFit: "fill" }}
          />
        </BlockContainer>
      </CampaignContainer>
      <SectionDownloading>
        <Text color="black" style={{ opacity: 0.5 }}>
          Downloading [1/2]
        </Text>
      </SectionDownloading>
    </DeviceContainer>
  );
};
